<template>
  <aha-modal
    :title="titleDontLoseOut"
    ref="remove-card-info-popup"
    id="remove-card-info-popup"
    @hide="handleStayBtn()"
  >
    <img
      src="@/assets/images/elements/dont-leave-subscription.svg"
      class="ml-auto mr-auto mb-4"
    >
    <p class="mb-4">
      <span v-html="$i18nPresenter.t('yourPlanCurrentlyOldPricingScheme')"></span>
    </p>
    <p class="mb-4">
      {{ $i18nPresenter.t('If you cancel your plan and buy a new one, you’ll pay the updated price.') }}
    </p>
    <p>{{ $i18nPresenter.t('Are you sure you want to continue?') }}</p>
    <template #action>
      <aha-button
        @click="handleStayBtn"
        has-margin-right
      >
        {{ $i18nPresenter.t('Stay') }}
      </aha-button>
      <aha-link
        @click="handleContinueBtn"
      >
        <span class="font-bold">{{ $i18nPresenter.t('Continue') }}</span>
      </aha-link>
    </template>
  </aha-modal>
</template>
<script>
export default {
  name: 'CancelSubInfo',
  data() {
    return {
      titleDontLoseOut: this.$i18nPresenter.t('Don’t lose out!'),
    }
  },
  mounted() {
  },
  methods: {
    handleContinueBtn() {
      this.$router.push({ name: 'UserCancelSub' })
    },
    handleStayBtn() {
      this.$emit('close')
    },
  },
}
</script>
